import { z } from 'zod';
import { Confirmation } from '@pages/Confirmation';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/connect/_authenticated/confirmation')({
  component: Confirmation,
  validateSearch: z.object({
    trackingId: z.string(),
  }),
});
